import React from "react";
import PhoneInput from "antd-phone-input";
import { Form } from "antd";

import { _isPhoneNumber } from "utils/form/simple-validation";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";

import styles from "./phoneInput.module.css";
import { Rule } from "antd/es/form";

interface PhoneNumberInputProps {
  name: string;
  disabled?: boolean;
  placeholder?: string;
  autoComplete?: string;
  disableDropdown?: boolean;
  /** По дефолту проверяется только на корректность формата номера телефона для России*/
  rules?: Rule[];
}

export const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  name,
  disabled = false,
  placeholder = "Номер телефона",
  autoComplete = "off",
  rules,
}) => {
  return (
    <Form.Item
      name={name}
      rules={[_isPhoneNumber(), ...(rules ?? [])]}
      className={styles.formItem}
      validateDebounce={FORM_VALIDATION_DEBOUNCE}
    >
      <PhoneInput autoComplete={autoComplete} disabled={disabled} placeholder={placeholder} disableDropdown={true} />
    </Form.Item>
  );
};
